export default __webpack_public_path__ + "static/media/chapter-step1.10c88e0e.gif";